GDPR text goes here with a button

<button mat-flat-button
    color="primary"
    (click)="onConfirm()"
    [disabled]="onProcess"
>
    <span *ngIf="!onProcess">CONFIRM</span>

    <mat-progress-spinner
        *ngIf="onProcess"
        [diameter]="24"
        [mode]="'indeterminate'"></mat-progress-spinner>
</button>

<button mat-flat-button (click)="onClose()" [disabled]="onProcess">CLOSE</button>
